import React from 'react';

function About() {
  return (
    <div
      id="about"
      className="bg-slate-900 text-white px-6 py-16 scroll-mt-28"
    >
      <h2 className="text-4xl font-extrabold mb-10 text-center">About</h2>

      <div className="flex flex-col md:flex-row items-center md:items-start gap-10 max-w-6xl mx-auto">
        <img
          src="/ravi.jpg"
          alt="Ravi"
          className="w-44 h-44 rounded-full object-cover object-top shadow-lg border-2 border-gray-600"
        />

        <div className="text-lg leading-relaxed max-w-3xl text-left space-y-4">
          <p>
            I'm a <strong>DevOps Engineer</strong> with 2+ years of experience designing CI/CD pipelines,
            managing Kubernetes (EKS) infrastructure, and automating cloud provisioning using Terraform.
          </p>
          <p>
            I specialize in building scalable, secure, and observable cloud-native platforms. My expertise
            spans cloud automation, DevSecOps, infrastructure as code, and production-grade Kubernetes management.
          </p>

          <ul className="list-disc list-inside ml-4 space-y-1">
            <li><strong>Cloud Platforms:</strong> AWS (EKS, EC2, VPC, IAM, RDS, S3), GCP, DigitalOcean</li>
            <li><strong>CI/CD & GitOps:</strong> GitLab CI/CD, Jenkins, ArgoCD, AWS CodePipeline</li>
            <li><strong>IaC & Automation:</strong> Terraform, Ansible, Shell scripting</li>
            <li><strong>Containers & Orchestration:</strong> Docker, Kubernetes, Helm</li>
            <li><strong>Monitoring & Logging:</strong> Prometheus, Grafana, Loki, Elasticsearch, New Relic</li>
            <li><strong>Security & Compliance:</strong> IAM, Trivy, Snyk, SonarQube</li>
            <li><strong>Networking & Web:</strong> NGINX, Apache, VPN, NAT Gateways</li>
            <li><strong>Systems & Databases:</strong> Linux (Ubuntu/Unix), MySQL, Redis</li>
          </ul>

          <p>
            I've delivered end-to-end DevOps solutions for:
          </p>

          <ul className="list-disc list-inside ml-4 space-y-1">
            <li><strong>WareIQ Logistics</strong> – multi-cloud automation for eCommerce infrastructure at scale</li>
            <li><strong>Bizmagnets AI</strong> – AWS-hosted pipelines and Kubernetes operations</li>
            <li><strong>Vamo Systems</strong> – DigitalOcean-based GPS tracking platform with 30k+ devices</li>
            <li><strong>Athulya Senior Care</strong> – containerized DevOps workflows on DigitalOcean</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default About;
